import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import * as S from "./styles";
import { BodyG, BodyP } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";

const chartAreaBorder = {
  id: "chartAreaBorder",
  afterDraw: (chart, args, options) => {
    const { ctx, chartArea } = chart;
    if (!chartArea) return;

    const { left, top, right, bottom } = chartArea;
    const width = right - left;
    const height = bottom - top;

    ctx.save();
    ctx.strokeStyle = options?.borderColor || "rgba(0, 0, 0, 0.15)";
    ctx.lineWidth = options?.borderWidth ?? 1;
    const offset = ctx.lineWidth % 2 === 0 ? 0 : 0.5;
    ctx.strokeRect(left + offset, top + offset, width - offset * 2, height - offset * 2);
    ctx.restore();
  },
};

const RainForecastGraphic = () => {
  const [rainData, setRainData] = useState([]);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const apiKey = "6e2f29917acaae3dc007e68b03ebaf54";
        const city = "São Paulo"; 
        const response = await axios.get(
          `https://api.openweathermap.org/data/2.5/forecast?q=${city}&cnt=40&appid=${apiKey}&units=metric&lang=pt_br`
        );

        const data = response.data.list;

        let dailyRainData = {};
        let dailyDates = [];

        for (let i = 0; i < data.length; i++) {
          const date = new Date(data[i].dt * 1000).toLocaleDateString("en", {
            day: "numeric",
            month: "short",
          });

          const rainValue = data[i].rain?.["3h"] || 0;

          if (!dailyRainData[date]) {
            dailyRainData[date] = rainValue;
            dailyDates.push(date);
          } else {
            dailyRainData[date] = Math.max(dailyRainData[date], rainValue);
          }
        }
        
        const uniqueDates = Array.from(new Set(dailyDates));
        const rainValues = uniqueDates.map(date => dailyRainData[date]);

        setRainData(rainValues);
        setDates(uniqueDates);
      } catch (error) {
        console.error("Erro ao buscar dados climáticos:", error);
      }
    };

    fetchWeatherData();
  }, []);

  const chartData = {
    labels: dates,
    datasets: [
      {
        label: "Chuva esperada (mm)",
        data: rainData,
        backgroundColor: "rgba(54, 162, 235, 0.08)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        barPercentage: 0.6,
        categoryPercentage: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      chartAreaBorder: {
        borderColor: "rgba(0, 0, 0, 0.15)",
        borderWidth: 1,
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: {
            size: 10,
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 9,
          },
          display: true,
          minRotation: 0,
          maxRotation: 0,
        },
        stacked: false,
      },
      y: {
        title: {
          display: false,
          text: "Chuva (mm)",
          font: {
            size: 8,
          },
        },
        ticks: {
          font: {
            size: 11,
          },
        },
        // Largura fixa (igual ao width={28} do YAxis dos gráficos Recharts
        // logo acima/abaixo - ver GraphicPreview/index.js) - Chart.js não tem
        // uma prop de largura, então o jeito é forçar depois do cálculo
        // automático (afterFit), senão esse eixo fica mais largo que os
        // outros e os gráficos saem desalinhados entre si.
        afterFit: (scale) => {
          scale.width = 28;
        },
        beginAtZero: true,
        stacked: false,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <S.Container>
      <BodyP color={theme.colors.gray.Cinza_2} fontWeight={800}>
        Previsão de Chuva da semana
      </BodyP>

      <div className="chart-wrapper">
        <Bar data={chartData} options={options} plugins={[chartAreaBorder]} />
      </div>
    </S.Container>
  );
};

export default RainForecastGraphic;